import { Component } from 'react';
import { KeyCodes } from '~/keycodes';

function withActiveItemNavigation(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = { activeIndex: null };
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          activeIndex={this.state.activeIndex}
          clearActive={this.clearActive}
          onKeyDown={this.onKeyDown}
        />
      );
    }

    onKeyDown = (e, onEnter, onEsc) => {
      const { results, showAdvancedSearchOption } = this.props;
      if (!results) return;

      const { activeIndex } = this.state;
      const isSet = typeof activeIndex === 'number';
      let activeResult;
      let newActive;
      let isFinalOptionSelected;

      switch (e.which) {
        case KeyCodes.ENTER:
          e.preventDefault();
          activeResult = isSet ? results[activeIndex] : null;
          if (typeof onEnter === 'function') onEnter(activeResult, e);
          break;
        case KeyCodes.ESC:
          e.preventDefault();
          activeResult = results[activeIndex];
          if (typeof onEsc === 'function') onEsc(activeResult);
          break;
        case this.getDecrementKey():
          e.preventDefault();
          if (isSet && activeIndex > 0) {
            newActive = activeIndex - 1;
          } else {
            newActive = showAdvancedSearchOption ? results.length : results.length - 1;
          }

          this.setState({ activeIndex: newActive });
          break;
        case this.getIncrementKey():
          e.preventDefault();
          isFinalOptionSelected =
            (showAdvancedSearchOption && activeIndex === results.length) ||
            (!showAdvancedSearchOption && activeIndex === results.length - 1);

          newActive = !isSet || isFinalOptionSelected ? 0 : activeIndex + 1;
          this.setState({ activeIndex: newActive });
          break;
        default:
      }
    };

    clearActive = () => {
      this.setState({ activeIndex: null });
    };

    getIncrementKey = () => {
      const incrementKey = this.props.horizontal ? KeyCodes.RIGHT_ARROW : KeyCodes.DOWN_ARROW;
      return this.props.invert ? incrementKey - 2 : incrementKey;
    };

    getDecrementKey = () => {
      const decrementKey = this.props.horizontal ? KeyCodes.LEFT_ARROW : KeyCodes.UP_ARROW;
      return this.props.invert ? decrementKey + 2 : decrementKey;
    };
  };
}

export default withActiveItemNavigation;
